import React, { useRef, useState, useEffect } from 'react';
import { FormControlLabel, Grid, TextField, TextFieldProps } from '@material-ui/core';
import useDebounce from '../../hooks/useDebounce';
import { verifyDuplicateExamSessionName } from '../../services/validation/validation.service';
import { useStyles } from './AddSession.styles';
import { useStyles as addName } from './AddName.styles';
import { useTranslation } from 'react-i18next';
import useDocumentTitle from '../../hooks/DocumentTitle/documentTitle';
import { CheckboxOne } from '../CheckboxOne/CheckboxOne.component';
import { useLayoutContext } from '../../Context/Layout.context';
import { ModalWithButtons } from '../ModalWithButtons/ModalWithButtons.component';
interface IAddNameProps {
  handleAddName: (close: boolean, next: boolean, name: string) => void;
  onActivateTrainingSession?: (value: boolean) => void;
}

const AddName: React.FC<IAddNameProps> = (props) => {
  const classes = useStyles();
  const addNameClasses = addName();

  const { t } = useTranslation();
  const { openAlert } = useLayoutContext();
  const [name, setName] = useState<string>('');
  const [saveDisable, setSaveDisable] = useState<boolean>(false);
  const [validName, setValidName] = useState<boolean>(true);
  const [isTrainingSession, setIsTrainingSession] = useState<boolean>(false);

  const debouncedInputName = useDebounce(name, 500);
  const textInputRef = useRef<TextFieldProps>();
  useEffect(() => {
    if (debouncedInputName) {
      verifyDuplicateExamSessionName(debouncedInputName).then(
        (result) => {
          setValidName(result);
        },
        () => openAlert('error'),
      );
    } else {
      setValidName(true);
    }
  }, [debouncedInputName]);

  const closeHandle = () => {
    props.handleAddName(true, false, '');
  };

  const handleNext = () => {
    props.handleAddName(false, true, name);
  };

  const handleName = (e: string) => {
    const newValue: string = e.trimStart();
    if (textInputRef.current && !e.trimStart().length) {
      textInputRef.current.value = newValue;
    }
    setName(newValue);
  };

  useEffect(() => {
    setSaveDisable(!name.trimStart().length);
  }, [name]);

  useDocumentTitle('Nowa sesja egzaminacyjna');
  return (
    <>
      <ModalWithButtons
        xCloseButton={closeHandle}
        open={true}
        size="lg"
        title={'Dodaj sesję'}
        confirmButtonLabel="Dalej"
        onConfirm={handleNext}
        confirmButtonDisabled={saveDisable || !validName}
        onCancel={closeHandle}
        handleClose={closeHandle}
        isHideBackdrop={true}
      >
        <Grid container justifyContent="center" alignItems="center">
          <div className={classes.numberCircleInline}>
            <div className={classes.numbersInCirclesInline}>1</div>
          </div>
          <div className={classes.textInline}>
            Dodaj nową <br /> sesję egzaminacyjną
          </div>
          <hr className={classes.line}></hr>
          <div className={classes.numberCircleOutline}>
            <div className={classes.numbersInCirclesOutline}>2</div>
          </div>
          <div className={classes.textOutline}>
            {!isTrainingSession ? (
              <div>
                <p>Import danych</p>
                <p>sesji egzaminacyjnej </p>
              </div>
            ) : (
              <div>
                <p>Zdefiniuj nową </p>
                <p>sesję egzaminacyjną </p>
              </div>
            )}
          </div>
        </Grid>
        <Grid container justifyContent="center">
          <div className={classes.middleText}>Dodaj nową sesję egzaminacyjną</div>
        </Grid>
        <Grid container justifyContent="center">
          <TextField
            inputRef={textInputRef}
            error={!validName}
            helperText={validName ? undefined : 'Podana nazwa sesji egzaminacyjnej już istnieje'}
            className={classes.formInput}
            name={name}
            onChange={(e) => handleName(e.target.value.trimStart().trimEnd())}
            id="Nazwa"
            label="Nazwa"
            placeholder="Nazwa"
            variant="outlined"
            inputProps={{
              style: {
                padding: '15.5px',
              },
            }}
          />
        </Grid>
        <Grid container justifyContent="center" className={addNameClasses.label}>
          <FormControlLabel
            control={
              <CheckboxOne
                name={'Sesja treningowa'}
                onClick={() => {
                  setIsTrainingSession(!isTrainingSession);
                  props.onActivateTrainingSession && props.onActivateTrainingSession(!isTrainingSession);
                }}
                checked={isTrainingSession}
              />
            }
            label="Sesja treningowa"
          />
        </Grid>
      </ModalWithButtons>
    </>
  );
};

export default AddName;
